var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5228",
    "data-name": "Group 5228",
    transform: "translate(-243 -371.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_person_24px",
    d: "M11.738,11.738A3.869,3.869,0,1,0,7.869,7.869,3.868,3.868,0,0,0,11.738,11.738Zm0,1.934C9.155,13.672,4,14.968,4,17.541v1.934H19.476V17.541C19.476,14.968,14.32,13.672,11.738,13.672Z",
    transform: "translate(239.884 369.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15601",
    "data-name": "Rectangle 15601",
    width: 18,
    height: 18,
    transform: "translate(243 371.665)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.04e15388b28d313b7f94281cfc42510e.svg";
export { ForwardRef as ReactComponent };